var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('charges-view',{on:{"reloadCharges":function($event){return _vm.fetchSocialSecurityContributions2($event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }